import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, tap } from 'rxjs';
import { KbService } from './kb.service';

@Injectable({
    providedIn: 'root',
})
export class TitleService {
    defaultTitle = '';
    routeTitle: any;
    constructor(
        private titleService: Title,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private _kbSer: KbService
    ) {
        this._kbSer.isLoadKbSetting.subscribe((res: boolean) => {
            if (res == true) {
                this.defaultTitle = this._kbSer.kbSettings.company_name;
                if (!this.router.url.includes('/article/')) {
                    this.setTitle();
                }
            }
        });
        this.setRouterEvent();
    }

    setRouterEvent(): void {
        this.router.events
            .pipe(filter((event) => event instanceof NavigationEnd))
            .subscribe(() => {
                const title = this.getTitle(this.activatedRoute);
                this.routeTitle = title;
                this.setTitle();
            });
    }

    getTitle(route: ActivatedRoute) {
        const title = route.snapshot.data['title'];
        if (title) {
            return title;
        } else if (route.firstChild) {
            return this.getTitle(route.firstChild);
        }
        return null;
    }

    setTitle(name?) {
        const titlePart = name || this.routeTitle || '';
        const suffix = this.defaultTitle
            ? titlePart
                ? ` - ${this.defaultTitle}`
                : this.defaultTitle
            : '';
        const title = `${titlePart}${suffix}`.trim();

        if (!title) {
            return;
        }

        this.titleService.setTitle(title);
    }
}
